export default __webpack_public_path__ + "static/media/rolesDesignOps.f6bc3606.svg";